
<button mat-icon-button id="modal-close-icon" class="no-hover-effect" (click)="cancel()">
  <mat-icon aria-label="Close">close</mat-icon>
</button>

<h1 mat-dialog-title>Debug Flags</h1>

<div mat-dialog-content>
  <mat-list #flagSelectionList dense class="list">
    <mat-list-item *ngFor="let flag of debugFlags | orderBy: 'name'"
     [ngClass]="{'debug-flag-with-metadata':flag.hasMetadata}" class=" pad_0 list-item">
     <div class="flex-box">
      <div class="pad_0">{{flag.name}}</div>
      <mat-form-field class="pad_0 form-field" *ngIf="flag.hasMetadata" (click)="onFieldClick($event)">
        <div *ngIf="flag.inputType === 'auto-complete'; else defaultInputType">
          <input matInput placeholder="Search Users" [matAutocomplete]="auto" [readonly]="itemCheckbox?.checked"
            [formControl]="userSearchCtrl" (ngModelChange)="onUpdateFlagMetaData(flag, $event)">
          <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selectUser($event)" [displayWith]="displayFn">
            <mat-option class="user-options" *ngFor="let user of (filteredUsers$ | async)" [value]="user">
                {{user.displayName}} ({{user.mail}})
            </mat-option>
          </mat-autocomplete>
          <mat-error *ngIf="userSearchCtrl?.hasError('loggedUserFound') && !impersonated">
              You cannot impersonate yourself.
            </mat-error>
            <mat-error *ngIf="userSearchCtrl?.hasError('userNotFound')">
              Username not found.
            </mat-error>
        </div>
        <ng-template #defaultInputType>
          <input matInput name="{{flag.name}}-metadata" placeholder="{{flag.metadataHint}}" (ngModelChange)="onUpdateFlagMetaData(flag, $event)" [(ngModel)]="flagMetadata[flag.name]">
        </ng-template>
      </mat-form-field>
    </div>
      <mat-checkbox class="checkbox" #itemCheckbox (ngModelChange)="getSelectionValue(flag)" [ngModel]="setCheckboxValue(flag)"></mat-checkbox>
    </mat-list-item>
  </mat-list>
</div>

<button mat-raised-button class="dbf-button" color="accent" (click)="logtoMegabeacon(flagSettingsList)" [mat-dialog-close]="updateReduceFlagSettings(flagSettingsList)" cdkFocusInitial>OK</button>
<button mat-button class="dbf-button" (click)="cancel()">CANCEL</button>



